// extracted by mini-css-extract-plugin
module.exports = {"previewTitle":"LeftSectionPage_previewTitle__1pq8p","previewImage":"LeftSectionPage_previewImage__3yyea"};